import { Button, Checkbox, Color, Dropdown, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SettingsAction } from '../../enums/settingsAction'
import { ReportOptions } from '../../types/reportOptions'
import { SETTINGS_CONFIG } from './consts/settingsConfig'
import * as Styled from './styles'

interface ViewSettingsProps {
  appliedFilters: ReportOptions
  availableSettings: SettingsAction[]
  setQueryParams: (params: Record<string, string>) => void
}

export const ViewSettings = ({ appliedFilters, setQueryParams, availableSettings }: ViewSettingsProps) => {
  const { t } = useTranslation()

  const handleValueClick = useCallback(
    (value: SettingsAction) => {
      const config = SETTINGS_CONFIG[value]
      if (!config) {
        return
      }

      const currentValue = appliedFilters[config.filterKey]
      setQueryParams({ [config.filterKey]: (!currentValue).toString() })
    },
    [appliedFilters, setQueryParams],
  )

  return (
    <Dropdown trigger={<Button variant="outlined" icon="settings" fullRound />} placement="bottom-end" size="xxl">
      <Styled.ViewSettingsContainer>
        <Flex flexDirection="column" gap={Spacing.S16}>
          <Text variant="bodySM" colorVariant="secondary" uppercase>
            {t('reports.filters.display_options')}
          </Text>
          {availableSettings.map((setting) => {
            const { filterKey, translationKey, tooltipKey } = SETTINGS_CONFIG[setting]
            return (
              <Checkbox
                key={setting}
                defaultChecked={!!appliedFilters[filterKey]}
                onChange={() => handleValueClick(setting)}
              >
                {tooltipKey ? (
                  <Flex alignItems="center" gap={Spacing.S6}>
                    <Text weight="bold">{t(translationKey)}</Text>
                    <Tooltip label={t(tooltipKey)} placement="bottom">
                      <Icon icon="info" color={Color.Grey300} />
                    </Tooltip>
                  </Flex>
                ) : (
                  <Text weight="bold">{t(translationKey)}</Text>
                )}
              </Checkbox>
            )
          })}
        </Flex>
      </Styled.ViewSettingsContainer>
    </Dropdown>
  )
}
